import { render, staticRenderFns } from "./RatingsSearchBox.vue?vue&type=template&id=10581f88&scoped=true&"
import script from "./RatingsSearchBox.vue?vue&type=script&lang=js&"
export * from "./RatingsSearchBox.vue?vue&type=script&lang=js&"
import style0 from "./RatingsSearchBox.vue?vue&type=style&index=0&id=10581f88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10581f88",
  null
  
)

export default component.exports